/* ============================================================
   HIT: comportamento das casas de marca (Yonex e On Running).
   Portado de projetos/design-propostas/direcao-b/index.html (o caso "ancora" do clique e animaParede).

     window.HitCasa = { rolaPara, animaParede }

   CHIPS DE SEÇÃO. Todo [data-act="ancora"] (um <a href="#alvo">, snippets/casa-chip) leva à seção #<data-alvo>. O chip de LINHA não passa
   por aqui: é um link comum para a coleção da linha. A rolagem usa scrollIntoView, e é o CSS que decide onde o alvo pousa
   (hit-casa.css, scroll-padding-top: abaixo do cabeçalho fixo e, na On, do índice de chips). O link direto #fam-<slug> usa a mesma regra
   do navegador, então o chip e o link direto pousam no mesmo lugar: como o cabeçalho encolhe durante a rolagem, uma correção única
   depois dela (corrigeDepoisDaRolagem) leva o alvo ao ponto que o CSS manda. Com prefers-reduced-motion a rolagem é seca. Alvo que não existe:
   não faz nada (o navegador segue o href).

   PAREDE. Na entrada da página, os tiles de cada grupo da parede de raquetes (.rgrp) se abrem da esquerda, com mola (HitMovimento.mover).
   Só roda onde há parede (a Yonex); sem prefers-reduced-motion; e só espera o Motion o tempo curto de ESPERA_MOTION ms. Se ele não vier
   (bloqueado, offline, devagar), NÃO anima: os tiles já estão à vista, e esconder e reabrir depois do prazo piscaria a parede.
   Carregar o arquivo duas vezes não faz nada na segunda.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined' || window.HitCasa) return;

  const REDUZ = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ESPERA_MOTION = 700; // ms
  const $$ = (s, r) => Array.prototype.slice.call((r || document).querySelectorAll(s));

  const COMPORTAMENTO = () => (REDUZ.matches ? 'auto' : 'smooth');
  const SILENCIO_MS = 160; // sem evento de rolagem por este tempo = a rolagem acabou

  /* O cabeçalho (#cab) encolhe quando a página desce, e o hit-medidas.js remede --h-topo no meio da rolagem. O scrollIntoView calculou o
     destino com o cabeçalho ALTO (do topo da página), então o alvo pousa 8 a 16 px abaixo do ponto do link direto (que o navegador refaz
     enquanto o layout muda). Acabada a rolagem, uma única correção leva o alvo ao ponto que o CSS manda: scroll-padding-top + scroll-margin-top. */
  function corrigeDepoisDaRolagem(el) {
    let t = 0;
    const termina = () => {
      window.removeEventListener('scroll', espera);
      const cs = window.getComputedStyle(document.documentElement), ce = window.getComputedStyle(el);
      const ponto = (parseFloat(cs.scrollPaddingTop) || 0) + (parseFloat(ce.scrollMarginTop) || 0);
      if (Math.abs(el.getBoundingClientRect().top - ponto) > 1) el.scrollIntoView({ block: 'start', behavior: COMPORTAMENTO() });
    };
    function espera() { clearTimeout(t); t = setTimeout(termina, SILENCIO_MS); }
    window.addEventListener('scroll', espera, { passive: true });
    espera();
  }

  function rolaPara(id) {
    const el = id ? document.getElementById(id) : null;
    if (!el) return false;
    el.scrollIntoView({ block: 'start', behavior: COMPORTAMENTO() });
    corrigeDepoisDaRolagem(el);
    return true;
  }

  /* o link direto: uma troca de hash com a página já aberta (location.hash, um <a href="#fam-x"> que o navegador resolve) tem o mesmo defeito do
     chip, então a mesma correção vale aqui. Só dentro da casa, e só para o id que existe */
  function ajustaHash() {
    let id = (window.location.hash || '').slice(1);
    try { id = decodeURIComponent(id); } catch (e) { return; } // hash malformado (%E0%A4%A): não é id de nada
    const el = id ? document.getElementById(id) : null;
    if (el && el.closest('.casa')) corrigeDepoisDaRolagem(el);
  }
  window.addEventListener('hashchange', ajustaHash);

  document.addEventListener('click', (ev) => {
    const b = ev.target && ev.target.closest ? ev.target.closest('[data-act="ancora"]') : null;
    if (b && rolaPara(b.getAttribute('data-alvo'))) {
      ev.preventDefault(); // a rolagem é nossa: o href #alvo não escreve a URL nem pula antes da animação
      const alvo = b.getAttribute('data-alvo');
      $$('[data-act="ancora"]').forEach((p) => {
        if (p.getAttribute('data-alvo') === alvo) p.setAttribute('aria-current', 'true');
        else p.removeAttribute('aria-current');
      });
    }
  });

  function animaParede() {
    const mov = window.HitMovimento;
    if (REDUZ.matches || !mov || !document.querySelector('.parede')) return;
    mov.carregaMotion(ESPERA_MOTION).then((motion) => {
      if (!motion) return;
      $$('.rgrp').forEach((g) => {
        const ts = $$('.rt', g);
        const rts = g.querySelector('.rts');
        if (ts.length < 2 || !rts) return;
        const w = ts[0].getBoundingClientRect().width + (parseFloat(window.getComputedStyle(rts).columnGap) || 8);
        ts.forEach((t, k) => {
          if (k) mov.mover(t, { transform: 'translate(' + (-k * w) + 'px,0px)', opacity: 0 }, { transform: 'translate(0px,0px)', opacity: 1 }, { mola: true, atraso: k * 0.04 });
        });
      });
    });
  }

  window.HitCasa = Object.freeze({ rolaPara, animaParede });
  animaParede();
})();
